import { Link } from "react-router-dom";
import { ArrowRight, MapPin, TrendingDown, PiggyBank } from "lucide-react";
import { IMAGES } from "../data/content";

const CASES = [
  {
    title: "Maison individuelle 130 m² · Strasbourg",
    project: "Pompe à chaleur air/eau + Isolation combles",
    image: IMAGES.house1,
    savings: "1 620 €/an",
    aides: "12 400 €",
    reste: "3 800 €",
    duration: "3 jours",
  },
  {
    title: "Villa contemporaine 180 m² · Colmar",
    project: "Rénovation globale + Clim réversible",
    image: IMAGES.house2,
    savings: "2 100 €/an",
    aides: "18 900 €",
    reste: "6 500 €",
    duration: "5 jours",
  },
  {
    title: "Appartement 75 m² · Mulhouse",
    project: "Clim réversible multi-split",
    image: IMAGES.clim,
    savings: "480 €/an",
    aides: "1 250 €",
    reste: "3 200 €",
    duration: "1 jour",
  },
  {
    title: "Maison de village 90 m² · Haguenau",
    project: "Isolation combles à 1€ + PAC",
    image: IMAGES.isolation,
    savings: "1 350 €/an",
    aides: "9 800 €",
    reste: "1 900 €",
    duration: "2 jours",
  },
];

export default function Realizations() {
  return (
    <div data-testid="realizations-page" className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="eyebrow">Nos réalisations</div>
        <h1 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-[0.95] tracking-tight">
          Des <span className="text-[#7DD923]">chantiers</span><br/>qui parlent d'eux-mêmes
        </h1>
        <p className="text-white/70 mt-4 max-w-2xl">
          Découvrez quelques-unes de nos réalisations récentes en Alsace, avec chiffres à l'appui.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mt-14">
          {CASES.map((c, i) => (
            <div
              key={i}
              data-testid={`case-${i}`}
              className="bg-[#121212] border border-white/5 rounded-3xl overflow-hidden hover:border-[#7DD923]/40 transition-colors group"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute top-4 left-4 bg-black/70 backdrop-blur-md px-3 py-1.5 rounded-full text-xs text-white flex items-center gap-1.5">
                  <MapPin className="w-3 h-3 text-[#7DD923]" /> Alsace
                </div>
              </div>
              <div className="p-6">
                <div className="text-xs uppercase tracking-widest text-[#7DD923] font-bold">{c.project}</div>
                <h3 className="font-display text-white text-xl mt-2 tracking-tight">{c.title}</h3>
                <div className="grid grid-cols-3 gap-3 mt-5 pt-5 border-t border-white/5">
                  <div>
                    <div className="text-[10px] uppercase tracking-widest text-white/40">Économies</div>
                    <div className="text-[#7DD923] font-display text-xl mt-1 flex items-center gap-1"><TrendingDown className="w-4 h-4" /> {c.savings}</div>
                  </div>
                  <div>
                    <div className="text-[10px] uppercase tracking-widest text-white/40">Aides</div>
                    <div className="text-white font-display text-xl mt-1 flex items-center gap-1"><PiggyBank className="w-4 h-4 text-[#7DD923]" /> {c.aides}</div>
                  </div>
                  <div>
                    <div className="text-[10px] uppercase tracking-widest text-white/40">Reste à charge</div>
                    <div className="text-white font-display text-xl mt-1">{c.reste}</div>
                  </div>
                </div>
                <div className="text-white/50 text-xs mt-4">Chantier réalisé en {c.duration}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link to="/devis" className="btn-primary" data-testid="realizations-cta">
            Démarrer mon projet <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
